import React from 'react';

const InstagramLink = props =>
  <a
    rel="noopener"
    target="_blank"
    href="https://instagram.com/depop/"
    {...props}>
    Instagram
  </a>;

export default InstagramLink;



// WEBPACK FOOTER //
// ../src/client/components/layout/navigation/links/InstagramLink.js